import { Component, OnInit } from '@angular/core';
import { StakeholdersService } from "./stakeholders.service";
import { StakeholdersModel } from "./stakeholders.model";
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-stakeholders',
  templateUrl: './stakeholders.component.html'
})
export class StakeholdersComponent extends Components implements OnInit {

  stakeholders: StakeholdersModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };

  constructor(
    private stakeholdersService: StakeholdersService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].id_acao == '24') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.stakeholdersService.getPaginacao(1, this.itensPorPagina)
      .subscribe(data => {
        this.stakeholders = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.stakeholders);
        }
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  delete(stakeholder) {
    let stakeholders = this.stakeholders;
    let stakeholdersService = this.stakeholdersService;
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarStakeholder') + (stakeholder.nome || ''),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(stakeholders);
        }

        let index = stakeholders.indexOf(stakeholder);
        stakeholders.splice(index, 1);

        stakeholdersService.apagar(stakeholder.id)
          .subscribe(res => {
            self.stakeholders = stakeholders;
          },
            err => {
              stakeholders.splice(index, 0, stakeholder);
              self.stakeholders = stakeholders;
              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.stakeholdersService.getPaginacao(pagina, this.itensPorPagina)
      .subscribe(data => {
        this.stakeholders = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-stakeholders/stakeholders.component.ts